import styled from '@olxui/core/dist/theme/styled';
import { ButtonLoading } from '@olxui/core/dist/core/Button';

export const SubmitButtonsWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.space[8]};
    flex-direction: column;
`;

export const SendRequestButton = styled(ButtonLoading)`
    width: 100%;
`;
